export const featureFlagsMixin = {
  data() {
    return {
      featuresFlags: {
      },
    };
  },
};
